@if (product) {
  <div class="d-flex align-items-center">
    @if (image) {
      <div class="product-icon me-3 d-flex justify-content-center align-items-center">
        <cx-media [alt]="image.altText" [container]="{url: image.url}" [title]="image.altText"></cx-media>
      </div>
    }
    <div class="d-flex flex-column">
      <div class="breadcrumbs-menu d-flex align-items-center position-absolute">
        <div
          (click)="launchSearchResult()"
          class="breadcrumbs-menu-link text-blue-grey body--xxs udex-cursor-pointer"
          tabindex="0">
          {{ 'productDetails.allProducts' | cxTranslate }}
        </div>
        <span class="separator">&#47;</span>
        @if (categories.length > 0) {
          <div
            (click)="showProductsForCategory(displayedCategory.code)"
            class="breadcrumbs-menu-link text-blue-grey body--xxs udex-cursor-pointer"
            tabindex="0">
            {{ displayedCategory.name }}
          </div>
        }
      </div>
      <dcp-limited-text
        aria-hidden="true"
        [charLimit]="110"
        [minimumHiddenText]="0"
        [showMoreOption]="false"
        [text]="product.name"
        class="product-title heading__regular--s">
      </dcp-limited-text>
      @if (product.vendor) {
        <div class="d-flex flex-nowrap body--xxs text-blue-grey">
          <span>{{ 'productDetails.by' | cxTranslate }}</span>
          <span class="ms-1">{{ product.vendor.name }}</span>
        </div>
      }
    </div>
  </div>
}
